import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { navData } from "../helper/navData";
import { useDispatch, useSelector } from "react-redux";
import { setUser, setUserLoggedIn } from "../actions";

const Header = () => {
  const [isNavOpen, setisNavOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const { totalProducts } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(setUserLoggedIn(false));
    dispatch(setUser(""));
    setisNavOpen(!isNavOpen);
  };

  return (
    <>
      <Wrapper>
        <div className="logo">Ollivander's</div>
        <nav>
          <ul>
            {navData.map(({ id, title, link }) => (
              <li key={id}>
                <Link to={link}>{title}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="login-and-cart">
          <Link to="/cart" className="cart">
            <span>Cart</span>
            <i className="fa-solid fa-cart-shopping"></i>
            <p>{totalProducts}</p>
          </Link>
          {user.loggedIn ? (
            <>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleLogout()}
                className="login"
              >
                <span>Logout</span>
                <i className="fa-solid fa-right-from-bracket"></i>
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="login">
                <span>Login</span>
                <i className="fa-solid fa-right-to-bracket"></i>
              </Link>
            </>
          )}
        </div>
      </Wrapper>
      <Responsive>
        <div className="logo">Ollivander's</div>
        <div
          className={`nav-toggler ${isNavOpen ? "toggled" : ""}`}
          onClick={() => setisNavOpen(!isNavOpen)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
        <nav className={isNavOpen ? "toggle-nav" : ""}>
          <ul>
            {navData.map(({ id, title, link }) => (
              <li key={id}>
                <Link onClick={() => setisNavOpen(!isNavOpen)} to={link}>
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          <div className="login-and-cart">
            <Link
              to={"/cart"}
              className="cart"
              onClick={() => setisNavOpen(!isNavOpen)}
            >
              <span>Cart</span>
              <i className="fa-solid fa-cart-shopping"></i>
              <p>{totalProducts}</p>
            </Link>

            {user.loggedIn ? (
              <>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handleLogout()}
                  className="login"
                >
                  <span>Logout</span>
                  <i className="fa-solid fa-right-from-bracket"></i>
                </div>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="login"
                  onClick={() => setisNavOpen(!isNavOpen)}
                >
                  <span>Login</span>
                  <i className="fa-solid fa-right-to-bracket"></i>
                </Link>
              </>
            )}
          </div>
        </nav>
      </Responsive>
    </>
  );
};

const Responsive = styled.header`
  height: 60px;
  width: 100vw;
  padding: 0 6vw;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* position: sticky;
  top: 0; */
  background-color: var(--color-white);
  z-index: 1000;

  .logo {
    font-size: 2.5em;
    font-weight: 800;
    font-family: var(--font-family-2);
  }
  .nav-toggler {
    width: 25px;
    cursor: pointer;
    position: relative;
    > div {
      width: 25px;
      height: 3px;
      background-color: var(--color-black-2);
      transition: all 300ms ease-in-out;
      :nth-child(2) {
        width: 15px;
        margin: 5px 0;
        margin-left: auto;
      }
    }
  }
  .toggled {
    > div {
      :nth-child(1) {
        transform: rotate(45deg) translateY(11px);
      }
      :nth-child(2) {
        opacity: 0;
        transform: translateX(-200%);
      }
      :nth-child(3) {
        transform: rotate(-45deg) translateY(-11px);
      }
    }
  }
  nav {
    top: 60px;
    left: 0;
    width: 100vw;
    padding: 0 10vw;
    background: var(--color-white);
    color: var(--color-primary-3);
    transition: all 300ms ease-in-out;
    height: 0;
    overflow: hidden;
    z-index: 100 !important;
    position: fixed;

    ul {
      list-style: none;
      a {
        display: block;
        text-decoration: none;
        font-size: 1em;
        color: var(--color-black-2);
        padding: 0.5em 0;
        margin: 0.5em 0;
        border-bottom: 2px solid transparent;
      }
    }
    .login-and-cart {
      font-size: 1.2em;
      display: flex;
      margin: 1em 0;
      .cart,
      .login {
        display: flex;
        align-items: center;
        margin-right: 1em;
        text-decoration: none;
        color: var(--color-black-1);
        > span {
          margin-right: 0.25em;
        }
        > i {
          font-size: 0.8em;
        }
      }
      .cart > p {
        position: relative;
        display: grid;
        font-size: 0.5em;
        background-color: var(--color-primary-1);
        color: var(--color-white);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        place-content: center;
        top: -10px;
        left: -5px;
      }
    }
  }
  .toggle-nav {
    padding-bottom: 20px;
    height: 100%;
  }
  @media screen and (min-width: 801px) {
    display: none;
  }
`;

const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 80vw;
  margin: 10px auto;
  height: 60px;
  overflow: hidden;

  .logo {
    font-size: 2.5em;
    font-weight: 800;
    font-family: var(--font-family-2);
    /* text-shadow: 0 0 10px #00000081; */
  }

  nav {
    ul {
      display: flex;
      list-style: none;
      a {
        display: block;
        text-decoration: none;
        font-size: 1em;
        color: var(--color-black-2);
        padding: 0.5em;
        margin: 0.5em;
        border-bottom: 2px solid transparent;
      }
      a:hover {
        border-bottom-color: var(--color-primary-1);
      }
    }
  }

  .login-and-cart {
    font-size: 1.2em;
    display: flex;
    .cart,
    .login {
      display: flex;
      align-items: center;
      margin-right: 1em;
      text-decoration: none;
      color: var(--color-black-1);
      > span {
        margin-right: 0.25em;
      }
      > i {
        font-size: 0.8em;
      }
    }
    .cart > p {
      position: relative;
      display: grid;
      font-size: 0.5em;
      background-color: var(--color-primary-1);
      color: var(--color-white);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      place-content: center;
      top: -10px;
      left: -5px;
    }
  }

  @media screen and (max-width: 600px) {
    width: 90vw;
  }

  @media screen and (max-width: 800px) {
    display: none;
    .logo {
      font-size: 2em;
    }
  }
`;

export default Header;
